

















































































// @ is an alias to /src
import FileSelector from "@/components/FileSelector.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    FileSelector
  }
})
export default class Home extends Vue {
  processDataFile(file: File) {
    if (file) {
      this.$emit("data-file-changed", file);
    }
  }
  loadSampleData() {
    this.$emit("data-file-changed", "/data/sample.tsv");
  }
}
